module.exports = __webpack_public_path__ + "static/img/rank_270.2597fb6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/rank_270.png
// module id = n29w
// module chunks = 1